import React, { useState, useEffect, useMemo, useRef } from 'react';
import axios from 'axios';
import { useHistory } from "react-router-dom";
import { useParams } from "react-router-dom"
import MaterialTable from "material-table";
import Sidebar from '../../../../Template/Sidebar/Sidebar';
import Header from '../../../../Template/Header/Header';
import { baseUrl } from '../../../../../config';
import DatePicker from "react-datepicker";
import moment from 'moment'
import CloseIcon from '@mui/icons-material/Close';
import "react-datepicker/dist/react-datepicker.css";
import Typography from '@mui/material/Typography';

import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import Loader from 'react-loader-spinner';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { clickColor, inArray } from './../../../../../library/util';
import './../../css/profit.css'
import './../../css/tiered.css'
import { formatNumberWithToFixed } from '../commanFn';


// import Slider from '@mui/material/Slider';

import AsyncSelect from 'react-select/async';
import makeAnimated from 'react-select/animated';
import Box from '@mui/material/Box';
import Slider, { SliderThumb, SliderValueLabelProps } from '@mui/material/Slider';
import { styled } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
import axiosIntance from '../../../../../helper/axios';
// import Typography from '@mui/material/Typography';

// import Box from '@mui/material/Box';
const animatedComponents = makeAnimated();

const colourStyles = {
  menuList: styles => ({
    ...styles,
    background: 'white'
  }),
  option: (styles, { isFocused, isSelected }) => ({
    ...styles,
    background: isFocused
      ? 'lightblue'
      : isSelected
        ? '#2a7bc0'
        : undefined,
    zIndex: 1
  }),
  menu: base => ({
    ...base,
    zIndex: 100
  })
}


function Tiered(text) {
  // console.log('text')
  // console.log(text)
  // console.dir(text)
  const history = useHistory();
  const [selectedRow, setSelectedRow] = useState(null);

  const [selectedrowList, setSelectedRowList] = useState([]);


  const setRowBackground = (selectedRow) => {
    if (inArray(selectedRow.tableData.id, selectedrowList) == false) {
      setSelectedRowList(oldArray => [...oldArray, selectedRow.tableData.id]);
      setSelectedRow(selectedRow.tableData.id)
      console.log(selectedrowList)
    } else {
      setSelectedRow(500000)
      setSelectedRowList([])
    }
  }
  const { type } = useParams()
  let midTitle = '';
  console.log(type);
  if (type == 'campaign') {
    midTitle = 'Campaign ID'

  } else if (type == 'campaign_group') {
    midTitle = 'Campaign Group';

  }
  const [reportType, setReportType] = useState(type);

  // console.log('65='+reportType);
  const ReportTile = `Tiered Report: Group Category → ${midTitle} → Affiliate`;
  const [startDate, setStartDate] = useState(new Date(new Date().getFullYear(), new Date().getMonth(), 1));
  const [endDate, setEndDate] = useState(new Date(Date.now()).setHours(23, 59, 0, 0));
  const [productCategory, setProductCategory] = useState('');
  const [productCategoryArray, setProductCategoryArray] = useState([]);
  const [AFFID, setAFFID] = useState('');
  const [AFFIDArray, setAFFIDArray] = useState([]);
  const [C1, setC1] = useState('');
  const [C1Array, setC1Array] = useState([]);
  const [group, setgroup] = useState('');
  const [groupArray, setgroupArray] = useState([]);

  const [REFCB, setREFCB] = useState(false);
  const [Refund, setRefund] = useState('');
  const [CB, setCB] = useState('');




  const selectInputRef = useRef();
  const REFCBCheckBox = useRef();




  const loadGroupFn = (inputValue) =>
    new Promise((resolve) => {
      // console.log('Input='+inputValue);
      axiosIntance.get(baseUrl + '/reports/profitabilityDiagnosis/group?type=category', {}).then(response => {
        resolve(response.data.result.filter((i) =>
          i.label.toLowerCase().includes(inputValue.toLowerCase())
        ));

      });
    });


  const handleChange = (target) => {
    if (target != undefined) {
      setgroup(target.value);
    }
    //clearValue();
  }


  const handleSignOut = () => {
    window.localStorage.setItem('isLogin', false);
    history.push('/');
  }

  checkUserTypeFn(history);

  function checkUserTypeFn(history) {
    const userdata = JSON.parse(localStorage.getItem('userdata'));
    const usertype = userdata.type;
    console.log('in check usertype fn');
    console.log(usertype)
    //   if(usertype!='admin' && usertype!='superadmin' && usertype!='subadmin' && usertype!='user'){
    //     history.push('/');
    //  }

    if (usertype != 'owneradmin' && usertype != 'superadmin') {
      history.push('/');
    }
  }



  const [reportData, setReportData] = useState([])
  const [loader, setLoader] = useState(false)
  axiosIntance.defaults.timeout = 36000000;//10min
  const [message, setMessage] = useState('')
  const data = [['attribute', 'attribute2'], ['value1', 'value2']];
  const [successMsg, setSuccessMsg] = useState('')
  useEffect(() => {
    //fetchApi();
    //console.log(129)
    //loadGroupFn('');
    return () => {
      //console.log(132)
      //console.log('un subscribe')
      // window.location.reload(false);
      ResetFilter()
    }



  }, [midTitle])


  const ResetFilter = () => {
    if (REFCB == true)
      REFCBCheckBox.current.click();
    setMessage('')
    setEndDate(new Date(Date.now()))
    setStartDate(new Date(new Date().getFullYear(), new Date().getMonth(), 1));
    setgroup('');
    setREFCB(false);
    setRefund('');
    setCB('');
    setgroupArray([])
    setReportData([]);
    selectInputRef.current.clearValue();
  }



  const fetchApi = () => {
    console.log('here check')
    // console.log(startDate)

    if (startDate == null) {
      setMessage('Start Date must not be blank')
      return false;
    } if (endDate == null) {
      setMessage('End Date must not be blank')
      return false;
    } else {
      setMessage('')
    }
    setLoader(true)
    //console.log(groupOptions);
    //return false;
    let groupStr = groupArray.join('*');
    // console.log(groupStr);
    var response = {};
    response.data = {};
    response.data.result = [];
    setLoader(true);



    axiosIntance.get(baseUrl + '/reports/profitabilityDiagnosis/tiered/' + reportType + '?startdate=' + moment(startDate).format('YYYY-MM-DD HH:mm') + "&enddate=" + moment(endDate).format('YYYY-MM-DD HH:mm') + "&type=affid&group=" + groupStr + "&refund=" + Refund + "&cb=" + CB + "&refcb=" + REFCB, {}).then(response => {

      if (response.data.result.length > 0) {
        // console.log('data we have')
        response.data.result.forEach((i, j) => {

          try {

            i.revenue = "$" + formatNumberWithToFixed(i.revenue).toLocaleString();
            i.revenue_per_fe = "$" + formatNumberWithToFixed(i.revenue_per_fe).toLocaleString();
            i.revenue_per_order = "$" + formatNumberWithToFixed(i.revenue_per_order).toLocaleString();
            i.total_cpa_cost = "$" + formatNumberWithToFixed(i.total_cpa_cost).toLocaleString();
            i.cogs = "$" + formatNumberWithToFixed(i.cogs).toLocaleString();
            i.processing_cost = "$" + formatNumberWithToFixed(i.processing_cost).toLocaleString();

            i.reserve_cost = "$" + formatNumberWithToFixed(i.reserve_cost).toLocaleString();
            i.processing_plus_reserves = "$" + formatNumberWithToFixed(i.processing_plus_reserves).toLocaleString();
            i.total_shipping_cost = "$" + formatNumberWithToFixed(i.total_shipping_cost).toLocaleString();
            i.total_handling_cost = "$" + formatNumberWithToFixed(i.total_handling_cost).toLocaleString();
            i.cost_of_cs = "$" + formatNumberWithToFixed(i.cost_of_cs).toLocaleString();
            i.total_transactions_cost = "$" + formatNumberWithToFixed(i.total_transactions_cost).toLocaleString();
            i.void_dollar_amount = "$" + formatNumberWithToFixed(i.void_dollar_amount).toLocaleString();
            i.refund_dollar_amount = "$" + formatNumberWithToFixed(i.refund_dollar_amount).toLocaleString();
            i.chargeback_dollar_amount = "$" + formatNumberWithToFixed(i.chargeback_dollar_amount).toLocaleString();
            i.cashflow = "$" + formatNumberWithToFixed(i.cashflow).toLocaleString();
            i.net_profit = "$" + formatNumberWithToFixed(i.net_profit).toLocaleString();

            i.CPA = "$" + formatNumberWithToFixed(i.CPA.toLocaleString());
            i.cogs_per_fe = "$" + formatNumberWithToFixed(i.cogs_per_fe).toLocaleString();
            i.ship_cost_per_fe = "$" + formatNumberWithToFixed(i.ship_cost_per_fe).toLocaleString();
            i.handling_cost_per_fe = "$" + formatNumberWithToFixed(i.handling_cost_per_fe).toLocaleString();
            i.cost_of_cs_per_fe = "$" + formatNumberWithToFixed(i.cost_of_cs_per_fe).toLocaleString();
            i.transactions_cost_per_fee = "$" + formatNumberWithToFixed(i.transactions_cost_per_fee).toLocaleString();

            i.net_profit_per_fe = "$" + formatNumberWithToFixed(i.net_profit_per_fe).toLocaleString();
            i.net_profit_per_order = "$" + formatNumberWithToFixed(i.net_profit_per_order).toLocaleString();


            i.chargeback_dollar_percent = roundToTwo(i.chargeback_dollar_percent * 100) + "%";

            i.chargeback_rate_percent = roundToTwo(i.chargeback_rate_percent * 100) + "%";

            i.refund_dollar_percent = roundToTwo(i.refund_dollar_percent * 100) + "%";

            i.refund_rate_percent = roundToTwo(i.refund_rate_percent * 100) + "%";

            i.void_rate_percent = roundToTwo(i.void_rate_percent * 100) + "%";

            i.void_dollar_percent = roundToTwo(i.void_dollar_percent * 100) + "%";

            i.click_bump_rate = roundToTwo(i.click_bump_rate * 100) + "%";

            i.net_profit_margin = roundToTwo(i.net_profit_margin * 100) + "%";


          } catch (e) {
            console.log(e);
          }





        });
        setReportData(response.data.result);
        // console.log(response.data.result)
        setLoader(false)
        //setSuccessMsg('Data')
      } else {
        setLoader(false)
        setReportData([]);

      }

    }).catch(error => {
      setLoader(false)
      console.log(error);
      setMessage('Something went wrong');
    });
  }

  const fetchApiDownload = () => {

    let groupStr = groupArray.join('*');
    console.log(groupStr);
    const token = window.localStorage.getItem('token');
    window.location.href = baseUrl + '/reports/profitabilityDiagnosis/tiered/' + reportType + '/download?startdate=' + moment(startDate).format('YYYY-MM-DD HH:mm') + "&enddate=" + moment(endDate).format('YYYY-MM-DD HH:mm') + "&type=affid&group=" + groupStr + "&token=" + token;
  }

  const FilterSet = () => {
    // console.log('Filter resete');
    // console.log(group);
    if (group != '') {
      if (inArrayForString(group, groupArray) == false) {
        setgroupArray(oldArray => [...oldArray, group]);
        setgroup('');
      }
    }

    selectInputRef.current.clearValue();

    // console.log('Group')
    // console.log(group);
    // console.log(groupArray);
    //setgroup('');
    //setProductCategoryStr();
  }



  const deleteGroupFn = (item, index) => {
    console.log(item);
    removeItemOnce(groupArray, item);
    console.log(groupArray);

    let temp = groupArray.filter((category) => category !== item);
    console.log(temp);
    setgroupArray(temp);
  }


  function removeItemOnce(arr, value) {
    var index = arr.indexOf(value);
    if (index > -1) {
      arr.splice(index, 1);
    }
    return arr;
  }

  const PrettoSlider = styled(Slider)({
    color: '#337ab7',
    height: 8,
    '& .MuiSlider-track': {
      border: 'none',
    },
    '& .MuiSlider-thumb': {
      height: 24,
      width: 24,
      backgroundColor: '#fff',
      border: '2px solid currentColor',
      '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
        boxShadow: 'inherit',
      },
      '&:before': {
        display: 'none',
      },
    },
    '& .MuiSlider-valueLabel': {
      lineHeight: 1.2,
      fontSize: 10,
      background: 'unset',
      padding: 0,
      width: 25,
      height: 25,
      zIndex: -10,
      borderRadius: '50% 50% 50% 0',
      backgroundColor: '#337ab7',
      transformOrigin: 'bottom left',
      transform: 'translate(50%, -100%) rotate(-45deg) scale(0)',
      '&:before': { display: 'none' },
      '&.MuiSlider-valueLabelOpen': {
        transform: 'translate(50%, -100%) rotate(-45deg) scale(1)',
      },
      '& > *': {
        transform: 'rotate(45deg)',
      },
    },
  });





  return (

    <div id="wrapper" className>
      <Sidebar />
      <Header handleSignOut={handleSignOut} />



      <div></div>
      <div></div>
      <div></div>
      <div></div>

      <div className='errorMsg'>{message}</div>
      <div className='successMsg viewScreen'>{successMsg}</div>







      <section id="content-wrapper">
        <div className='FilterDivSection'>
          <label>Start Date</label>
          <label className='endDateStyle'>End Date</label>
          <label className='groupStyle'>Group</label>
          {!REFCB ? '' :
            <label className='RefundStyle'>Refund Percent</label>
          }
          {!REFCB ? '' :
            <label className='chargebackStyle'>Chargeback Percent</label>
          }

          <div className="input-bar">
            <div className="input-bar-item width100">

              <DatePicker
                dateFormat="yyyy-MM-dd HH:mm"
                showTimeSelect
                timeFormat="p"
                timeIntervals={15}
                selected={startDate}
                className='width140x'
                onChange={(date) => setStartDate(date)}
                placeholder='Start Date'
              />

            </div>

            &nbsp;&nbsp;&nbsp;

            <div className="input-bar-item width100">

              <DatePicker
                dateFormat="yyyy-MM-dd HH:mm"
                showTimeSelect
                timeFormat="p"
                timeIntervals={15}
                selected={endDate}
                className='width140x'
                onChange={(date) => setEndDate(date)}
                placeholder='End Date'
              />

            </div>
            &nbsp;&nbsp;&nbsp;


            <div className="input-bar-item width100">

              {/* <input 
    type="text" 
     name='group'
     className='width140x'
     value={group}
     placeholder="Group"
     onChange={e => setgroup(e.target.value)} 
     
      /> */}

              <AsyncSelect
                // ref={ref => {
                //   this.selectRef = ref;
                // }}
                ref={selectInputRef}
                hideSelectedOptions={false}
                components={animatedComponents}
                onChange={e => handleChange(e)}
                cacheOptions
                defaultOptions
                maxMenuHeight={250}
                className="widthSelectInput"
                classNamePrefix="select"
                styles={colourStyles}
                getOptionLabel={(e) => e.value}
                getOptionValue={(e) => e.value}
                loadOptions={loadGroupFn}

              />


            </div>
            &nbsp;&nbsp;&nbsp;




            <div className="checkboxDiv">
              <FormGroup>
                <FormControlLabel control={<Checkbox
                  ref={REFCBCheckBox}
                  sx={{ '& .MuiSvgIcon-root': { fontSize: 40 } }}
                  name='Estimate Refunds/CBs'
                  value={REFCB}
                  defaultChecked={REFCB}
                  onChange={() => setREFCB(!REFCB)}
                />}
                  label="Estimate Refunds/CBs" />
              </FormGroup>
            </div>

            {!REFCB ? '' :


              <div className="input-bar-item">

                {/* <input 
     
     name='group'
     className='width62x'
     value={Refund}
     pattern="[0-9.]+" type="number"
     placeholder="Refunds"
     onChange={e => setRefund(e.target.value)} 
     
      /> */}
                {/* <div>
<Box width={200}>

      <Slider
        size="large"
        marks
        defaultValue={0}
        aria-label="Refunds"
        valueLabelDisplay="auto"
        min={0}
        max={15}
        onChange={e => setRefund(e.target.value)} 
      />
      
    </Box>
    </div> */}



                <Box width={150}></Box>

                <PrettoSlider

                  aria-label="pretto slider"
                  defaultValue={0}

                  min={0}
                  max={15}
                  value={Refund}
                  onChange={e => setRefund(e.target.value)}
                  // valueLabelFormat={value => <div>{value}</div>}
                  step={1}
                  valueLabelDisplay="on"
                  marks


                />

                {/* <Slider
        valueLabelDisplay="on"
        defaultValue={2008}
        min={1998}
        max={2017}
        step={1}
      /> */}


              </div>
            }
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            {!REFCB ? '' :

              <div className="input-bar-item">

                {/* <input 
    
     name='group'
     className='width92x'
     value={CB}
     pattern="[0-9.]+" type="number"
     placeholder="Chargebacks"
     onChange={e => setCB(e.target.value)} 
     
      /> */}

                {/* <Box sx={{ m: 3 }} /> */}
                <Box width={150}></Box>
                <PrettoSlider

                  aria-label="pretto slider"
                  defaultValue={0}
                  min={0}
                  max={15}
                  value={CB}
                  onChange={e => setCB(e.target.value)}
                  step={1}
                  valueLabelDisplay="on"
                  marks
                />
              </div>
            }

            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <div className="input-bar-item">
              <button type="button" onClick={FilterSet} className="btn btn-primary">Filter</button>

            </div>

            <div className="input-bar-item">
              <button type="button" onClick={fetchApi} className="btn btn-primary">Run Report</button>

            </div>
            <div className='input-bar-item'>
              <button type="button" onClick={ResetFilter} className="btn btn-primary">Reset</button>
            </div>

            {/* <div className='downloadReportBtn'>
        {
          
          reportData.length>0 ? <button type="button"  onClick={fetchApiDownload} className="btn btn-primary">Download Report in Excel</button>:''
         
        }
       
      </div> */}

            <div className='downloadReportBtn'>
              {

                <button type="button" onClick={fetchApiDownload} className="btn btn-primary">Download Report in Excel</button>

              }

            </div>
          </div>



          <div className="FilterSection">

            {groupArray.map((item, index) => (
              <span className="FilterSection">
                <span className='filterCategory' id={index}><span className="filterSpan">Group = {item}{ }</span>
                  <span onClick={(event) => deleteGroupFn(item, index)}><CloseIcon className='closeIcon' /></span>
                </span>
                <span className="whitespaceSpan">{'            '}</span>
              </span>

            ))}





          </div>
        </div>





        {loader ?
          <div className='loaderDiv'>
            <Loader type="ThreeDots" color="#2BAD60" height="100" width="100" /></div> :




          <MaterialTable
            // onRowClick={((evt, selectedRow) => setSelectedRow(selectedRow.tableData.id))}
            onRowClick={((evt, selectedRow) =>
              setRowBackground(selectedRow)
            )}


            columns={[
              {
                title: "Group", field: "reportby",
                cellStyle: (e, rowdata) => {
                  if (rowdata.last == 1) {
                    return { fontWeight: 'bold' }
                  }
                }
              },
              {
                title: "Name.of.Group", field: "groupname",
                cellStyle: (e, rowdata) => {
                  if (rowdata.last == 1) {
                    return { fontWeight: 'bold' }
                  }
                }
              },
              {
                title: "Frontend", field: "front_end_count",
                cellStyle: (e, rowdata) => {
                  if (rowdata.last == 1) {
                    return { fontWeight: 'bold' }
                  }
                }
              },
              {
                title: "Total.Orders", field: "total_orders",
                cellStyle: (e, rowdata) => {
                  if (rowdata.last == 1) {
                    return { fontWeight: 'bold' }
                  }
                }
              },
              {
                title: "Total.Revenue", field: "revenue",
                cellStyle: (e, rowdata) => {
                  if (rowdata.last == 1) {
                    return { fontWeight: 'bold' }
                  }
                }
              },
              {
                title: "Revenue.per.FE", field: "revenue_per_fe",
                cellStyle: (e, rowdata) => {
                  if (rowdata.last == 1) {
                    return { fontWeight: 'bold' }
                  }
                }
              },
              {
                title: "Revenue.per.Order", field: "revenue_per_order",
                cellStyle: (e, rowdata) => {
                  if (rowdata.last == 1) {
                    return { fontWeight: 'bold' }
                  }
                }
              },
              {
                title: "Number.of.Click.Bump", field: "click_bump_count",
                cellStyle: (e, rowdata) => {
                  if (rowdata.last == 1) {
                    return { fontWeight: 'bold' }
                  }
                }

              },
              {
                title: "Click.Bump.Rate", field: "click_bump_rate",
                cellStyle: (e, rowdata) => {
                  if (rowdata.last == 1) {
                    return { fontWeight: 'bold' }
                  }
                }

              },
              {
                title: "CPA", field: "CPA",
                cellStyle: (e, rowdata) => {
                  if (rowdata.last == 1) {
                    return { fontWeight: 'bold' }
                  }
                }
              },
              {
                title: "Total.CPA.cost", field: "total_cpa_cost",
                cellStyle: (e, rowdata) => {
                  if (rowdata.last == 1) {
                    return { fontWeight: 'bold' }
                  }
                }

              },
              {
                title: "COGS", field: "cogs",
                cellStyle: (e, rowdata) => {
                  if (rowdata.last == 1) {
                    return { fontWeight: 'bold' }
                  }
                }
              },
              {
                title: "COGS.per.FE", field: "cogs_per_fe",

                cellStyle: (e, rowdata) => {
                  if (rowdata.last == 1) {
                    return { fontWeight: 'bold' }
                  }
                }
              },
              {
                title: "Processing.Cost", field: "processing_cost",
                cellStyle: (e, rowdata) => {
                  if (rowdata.last == 1) {
                    return { fontWeight: 'bold' }
                  }
                }
              },
              {
                title: "Reserves.Cost", field: "reserve_cost",
                cellStyle: (e, rowdata) => {
                  if (rowdata.last == 1) {
                    return { fontWeight: 'bold' }
                  }
                }
              },
              {
                title: "Processing.plus.Reserves", field: "processing_plus_reserves",
                cellStyle: (e, rowdata) => {
                  if (rowdata.last == 1) {
                    return { fontWeight: 'bold' }
                  }
                }

              },
              {
                title: "Total.Shipping.cost", field: "total_shipping_cost",
                cellStyle: (e, rowdata) => {
                  if (rowdata.last == 1) {
                    return { fontWeight: 'bold' }
                  }
                }

              },

              {
                title: "Shipping.per.FE", field: "ship_cost_per_fe",
                cellStyle: (e, rowdata) => {
                  if (rowdata.last == 1) {
                    return { fontWeight: 'bold' }
                  }
                }

              },

              {
                title: "Total.Handling.Cost", field: "total_handling_cost",
                cellStyle: (e, rowdata) => {
                  if (rowdata.last == 1) {
                    return { fontWeight: 'bold' }
                  }
                }

              },

              {
                title: "Handling.per.FE", field: "handling_cost_per_fe",
                cellStyle: (e, rowdata) => {
                  if (rowdata.last == 1) {
                    return { fontWeight: 'bold' }
                  }
                }
              },

              {
                title: "Cost.of.CS", field: "cost_of_cs",
                cellStyle: (e, rowdata) => {
                  if (rowdata.last == 1) {
                    return { fontWeight: 'bold' }
                  }
                }

              },
              {
                title: "CS.per.FE", field: "cost_of_cs_per_fe",

                cellStyle: (e, rowdata) => {
                  if (rowdata.last == 1) {
                    return { fontWeight: 'bold' }
                  }
                }

              },


              {
                title: "Total.Transaction.cost", field: "total_transactions_cost",

                cellStyle: (e, rowdata) => {
                  if (rowdata.last == 1) {
                    return { fontWeight: 'bold' }
                  }
                }

              },
              {
                title: "Transaction.cost.per.FE", field: "transactions_cost_per_fee",
                cellStyle: (e, rowdata) => {
                  if (rowdata.last == 1) {
                    return { fontWeight: 'bold' }
                  }
                }

              },

              {
                title: "Number.of.Voids", field: "number_of_voids",
                cellStyle: (e, rowdata) => {
                  if (rowdata.last == 1) {
                    return { fontWeight: 'bold' }
                  }
                }

              },
              {
                title: "Void.Rate.Percent", field: "void_rate_percent",

                cellStyle: (e, rowdata) => {
                  if (rowdata.last == 1) {
                    return { fontWeight: 'bold' }
                  }
                }
              },
              {
                title: "Void.Dollars.Amount", field: "void_dollar_amount",
                cellStyle: (e, rowdata) => {
                  if (rowdata.last == 1) {
                    return { fontWeight: 'bold' }
                  }
                }

              },
              {
                title: "Void.Dollars.Percent", field: "void_dollar_percent",
                cellStyle: (e, rowdata) => {
                  if (rowdata.last == 1) {
                    return { fontWeight: 'bold' }
                  }
                }

              },

              {
                title: "Number.of.Refunds", field: "number_of_refunds",
                cellStyle: (e, rowdata) => {
                  if (rowdata.last == 1) {
                    return { fontWeight: 'bold' }
                  }
                }

              },

              {
                title: "Refund.Rate.Percent", field: "refund_rate_percent",
                cellStyle: (e, rowdata) => {
                  if (rowdata.last == 1) {
                    return { fontWeight: 'bold' }
                  }
                }

              },

              {
                title: "Refund.Dollars.Amount	", field: "refund_dollar_amount",
                cellStyle: (e, rowdata) => {
                  if (rowdata.last == 1) {
                    return { fontWeight: 'bold' }
                  }
                }

              },
              {
                title: "Refund.Dollars.Percent", field: "refund_dollar_percent",
                cellStyle: (e, rowdata) => {
                  if (rowdata.last == 1) {
                    return { fontWeight: 'bold' }
                  }
                }

              },
              {
                title: "Number.of.Chargebacks", field: "chargeback_count",

                cellStyle: (e, rowdata) => {
                  if (rowdata.last == 1) {
                    return { fontWeight: 'bold' }
                  }
                }

              },

              {
                title: "Chargebacks.Rate.Percent", field: "chargeback_rate_percent",
                cellStyle: (e, rowdata) => {
                  if (rowdata.last == 1) {
                    return { fontWeight: 'bold' }
                  }
                }

              },
              {
                title: "Chargebacks.Dollars.Amount", field: "chargeback_dollar_amount",
                cellStyle: (e, rowdata) => {
                  if (rowdata.last == 1) {
                    return { fontWeight: 'bold' }
                  }
                }

              },
              {
                title: "Chargebacks.Dollars.Percent", field: "chargeback_dollar_percent",
                cellStyle: (e, rowdata) => {
                  if (rowdata.last == 1) {
                    return { fontWeight: 'bold' }
                  }
                }

              },
              {
                title: "Cashflow", field: "cashflow",
                cellStyle: (e, rowdata) => {
                  if (rowdata.last == 1) {
                    return { fontWeight: 'bold' }
                  }
                }

              },
              {
                title: "Net.Profit", field: "net_profit",
                cellStyle: (e, rowdata) => {
                  if (rowdata.last == 1) {
                    return { fontWeight: 'bold' }
                  }
                }

              },
              {
                title: "Net.Profit.per.FE", field: "net_profit_per_fe",
                cellStyle: (e, rowdata) => {
                  if (rowdata.last == 1) {
                    return { fontWeight: 'bold' }
                  }
                }
              },
              {
                title: "Net.Profit.per.Order", field: "net_profit_per_order",
                cellStyle: (e, rowdata) => {
                  if (rowdata.last == 1) {
                    return { fontWeight: 'bold' }
                  }
                }

              },
              {
                title: "Net.Profit.Margin", field: "net_profit_margin",
                cellStyle: (e, rowdata) => {
                  if (rowdata.last == 1) {
                    return { fontWeight: 'bold' }
                  }
                }

              }


            ]}
            data={
              reportData
            }
            title={ReportTile}
            parentChildData={(row, rows) => rows.find(a => a.id === row.parentId)}
            options={{
              // filtering:true,
              actionsColumnIndex: -1,
              addRowPosition: "first",
              pageSize: 10,
              loadingType: 'overlay',
              paging: false,
              exportButton: true,
              maxBodyHeight: '500px',

              headerStyle: { position: 'sticky', top: 0, fontSize: '17px', fontWeight: 'bold' },
              rowStyle: rowData => ({
                backgroundColor: (selectedRow === rowData.tableData.id) ? clickColor : ''
              })
            }}
          // components={{
          //   OverlayLoading: props => (<div>Heye</div>)
          // }}
          />
        }



      </section>

    </div>

  )
}

function roundToTwo(num) {
  return +(Math.round(num + "e+2") + "e-2");
}

function inArrayForString(needle, haystack) {
  var length = haystack.length;
  for (var i = 0; i < length; i++) {
    if (haystack[i].toLowerCase() == needle.toLowerCase())
      return true;
  }
  return false;
}


export default Tiered
